import { action } from 'typesafe-actions';

import { IKnoOrganisationChild } from 'APIPackage/CatalogsModule/interfaces/IKnoOrganisationChild';
import { IProsecutorOrganisationsChildrenResponse } from 'APIPackage/CatalogsModule/interfaces/IProsecutorOrganisationsChildrenResponse';

import { UserInfoActionsEnum } from '../enums/UserInfoActionsEnum';
import { IUserOrganisation } from '../../../APIPackage/AccountModule/interfaces/IUserOrganisation';

export const setIsReceiveUserOrg = () => action(UserInfoActionsEnum.SET_IS_RECEIVE_USER_ORG);
export const userInfoReset = () => action(UserInfoActionsEnum.USER_INFO_RESET);
export const userInfoUpdateOrganizations = (
  knoErvkIds: string[],
  prosecIds: string[],
  knoDefaultErvkId?: string | undefined,
  prosecDefaultId?: string | undefined,
) =>
  action(UserInfoActionsEnum.USER_INFO_UPDATE_ORGANIZATIONS, {
    knoErvkIds,
    prosecIds,
    knoDefaultErvkId,
    prosecDefaultId,
  });
export const userInfoSetDefaultFunction = (knoId: string, functionId: number) =>
  action(UserInfoActionsEnum.USER_INFO_SET_DEFAULT_FUNCTION, { knoId, functionId });
export const userInfoProsecutorOrganizationsGet = () =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_GET);
export const userInfoProsecutorOrganizationsGetRequest = () =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_REQUEST);
export const userInfoProsecutorOrganizationsGetSuccess = (data: IProsecutorOrganisationsChildrenResponse) =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_SUCCESS, { data });
export const userInfoProsecutorOrganizationsGetFailure = () =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_GET_FAILURE);
export const userInfoProsecutorOrganizationsNextPageGet = () =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET);
export const userInfoProsecutorOrganizationsNextPageGetRequest = () =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_REQUEST);
export const userInfoProsecutorOrganizationsNextPageGetSuccess = (data: IProsecutorOrganisationsChildrenResponse) =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_SUCCESS, { data });
export const userInfoProsecutorOrganizationsNextPageGetFailure = () =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_NEXT_PAGE_GET_FAILURE);
export const userInfoProsecutorOrganizationsSetDistrictId = (districtId: number | undefined) =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_DISTRICT_ID, {
    districtId,
  });
export const userInfoProsecutorOrganizationsSetSearchQuery = (searchQuery: string | undefined) =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_SEARCH_QUERY, {
    searchQuery,
  });
export const userInfoProsecutorOrganizationsSetParentId = (parentId: string | undefined) =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_PARENT_ID, {
    parentId,
  });
export const userInfoProsecutorOrganizationsSetSearchOgrn = (searchOgrn: string | undefined) =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_SET_SEARCH_OGRN, {
    searchOgrn,
  });
export const userInfoProsecutorOrganizationsReset = () =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_ORGANIZATIONS_RESET);
export const userInfoGetKnoAdminLevels = () => action(UserInfoActionsEnum.USER_INFO_GET_KNO_ADMIN_LEVELS);
export const userInfoGetOrganisations = () => action(UserInfoActionsEnum.USER_INFO_GET_ORGANISATIONS);
export const userInfoSetOrganisations = (
  knoOrganisations: IKnoOrganisationChild[],
  organisationsPage: string,
  organisationsPageCount: number,
  organisationsTotalCount: number,
) =>
  action(UserInfoActionsEnum.USER_INFO_SET_ORGANISATIONS, {
    knoOrganisations,
    organisationsPage,
    organisationsPageCount,
    organisationsTotalCount,
  });
export const userInfoSetOrganisationsSearchQuery = (organisationsSearchQuery?: string) =>
  action(UserInfoActionsEnum.USER_INFO_SET_ORGANIZATIONS_SEARCH_QUERY, {
    organisationsSearchQuery,
  });
export const userInfoSetOrganisationsParentId = (organisationsParentId?: string) =>
  action(UserInfoActionsEnum.USER_INFO_SET_ORGANIZATIONS_PARENT_ID, {
    organisationsParentId,
  });
export const userInfoGetOrganisationsNextPage = () => action(UserInfoActionsEnum.USER_INFO_GET_ORGANISATIONS_NEXT_PAGE);
export const userInfoSetOrganisationsAdminLevelCode = (organisationsAdminLevelCode?: string) =>
  action(UserInfoActionsEnum.USER_INFO_SET_ORGANIZATIONS_ADMIN_LEVEL_CODE, {
    organisationsAdminLevelCode,
  });
export const userInfoSetOrganisationsSearchCriteria = (value: boolean) =>
  action(UserInfoActionsEnum.USER_INFO_SET_ORGANIZATIONS_SEARCH_CRITERIA, { value });
export const userInfoKnoOrganizationsReset = () => action(UserInfoActionsEnum.USER_INFO_KNO_ORGANIZATIONS_RESET);
export const userInfoSetCurrentFunctionsModalId = (currentFunctionsModalId?: string) =>
  action(UserInfoActionsEnum.USER_INFO_SET_CURRENT_FUNCTIONS_MODAL_ID, { currentFunctionsModalId });
export const userInfoSetIsErvk = (value?: boolean) => action(UserInfoActionsEnum.USER_INFO_SET_IS_ERVK, { value });
export const userInfoSetHighlightedSelectedOrganisations = (organisations: IKnoOrganisationChild[]) =>
  action(UserInfoActionsEnum.USER_INFO_SET_HIGHLIGHTED_SELECTED_ORGANISATIONS, { organisations });
export const userInfoProsecutorsByOrganizationsGet = (ids: { id: string }[]) =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_BY_ORGANIZATIONS_GET, { ids });
export const userInfoProsecutorsByOrganizationsGetSuccess = (data: IUserOrganisation[]) =>
  action(UserInfoActionsEnum.USER_INFO_PROSECUTOR_BY_ORGANIZATIONS_GET_SUCCESS, { data });
